import {useEffect, useState} from "react";

export const useModelviewerScripts = host => {
    const [scripts, setScripts] = useState([])
    const [styles, setStyles] = useState([])

    useEffect(() => {
        fetch(`${host}/asset-manifest.json`)
            .then(res => res.json())
            .then(manifest => {
                setScripts(
                        manifest['entrypoints'].filter(entrypoint => entrypoint.endsWith('.js'))
                            .map(entrypoint => ({
                                scriptName: entrypoint.split('/').slice(-1),
                                entrypoint: entrypoint
                            }))

                    )
                setStyles(
                    manifest['entrypoints'].filter(entrypoint => entrypoint.endsWith('.css'))
                        .map(entrypoint => ({
                            styleName: entrypoint.split('/').slice(-1),
                            entrypoint: entrypoint
                        }))
                )
                }
            )
    }, [host])

    return {
        scripts: scripts,
        styles: styles
    }
}